import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ClockCounterClockwise } from "@phosphor-icons/react";
import { Shell } from "@/components/Shell";
import { EventsManager } from "@/components/EventsManager";
import { useApp } from "@/context/AppContext";
import api from "@/lib/api";

export default function Activity() {
  const { t } = useApp();
  const [events, setEvents] = useState(null);

  const load = () => api.get("/activity").then((r) => setEvents(r.data)).catch(() => setEvents([]));
  useEffect(() => { load(); }, []);

  return (
    <Shell back="/dashboard">
      <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} className="space-y-4" data-testid="activity-page">
        <div className="flex items-center gap-2">
          <ClockCounterClockwise size={28} weight="duotone" style={{ color: "var(--app-strong)" }} />
          <div>
            <h1 className="text-2xl font-heading font-semibold text-gray-900">{t("activityTitle")}</h1>
            <p className="font-body text-sm text-gray-500">{t("activitySubtitle")}</p>
          </div>
        </div>
        {events === null ? <p className="font-body text-gray-500">…</p> : <EventsManager events={events} showBuddy onChange={load} />}
      </motion.div>
    </Shell>
  );
}
